const routes = {
  root: '',
  auth: {
    root: '/auth',
    login: '/login',
    create_password: '/sign-up',
    forgot_password: '/forgot-password',
    forgot_password_reset: '/members/forgot_password_reset',
    forgot_password_submission: '/forgot-password-submission',
  },
  profile: '/setup-profile',
};

export default routes;
